import { HTMLAttributes } from 'react';
import tw from 'twin.macro';
import 'styled-components/macro';

import { Button } from 'play/atoms/button/Button';

export interface ProgressButtonProps {
  className?: string;
  challengeCount: number;
  challengesCompleted: number;
  currentChallengeIndex?: number;
  onClick?: HTMLAttributes<HTMLButtonElement>['onClick'];
  challengeTimer?: React.ReactNode;
}

export const ProgressButton = ({
  className,
  challengeCount,
  challengesCompleted,
  currentChallengeIndex,
  onClick,
  challengeTimer,
}: ProgressButtonProps) => (
  <Button variant="outline" tw="px-1 py-half text-left flex" onClick={onClick} className={className}>
    <div tw="flex-grow">
      <div tw="flex justify-between">
        <div tw="text-base leading-none mb-1">Progress</div>
      </div>
      <div tw="flex flex-row gap-half">
        {Array(challengeCount)
          .fill(null)
          .map((_, index) => (
            <div
              key={index}
              tw="relative flex-1 [height: 2px] [border-radius: 4px] overflow-hidden"
              css={[index < challengesCompleted ? tw`bg-green` : tw`bg-[#575D67]`]}
            >
              {index === currentChallengeIndex && <div tw="absolute h-full w-full animate-pulse bg-white" />}
            </div>
          ))}
      </div>
    </div>
    {challengeTimer}
  </Button>
);
